export default {
    ADD_FIELD: 'ADD_FIELD',
    EDIT_FIELD: 'EDIT_FIELD',
    DELETE_FIELD: 'DELETE_FIELD',
    UPDATE_FULL_FIELDS: 'UPDATE_FULL_FIELDS',
    UPDATE_REORDERED_FIELDS: 'UPDATE_REORDERED_FIELDS'
  };